<template>
  <div class="select_temp">
    <div class="select_border" @click="toSelect($event)">
      <div class="left_text">
        <span>{{ selectName }}</span>
      </div>
      <div class="right_icon">
        <Icon type="ios-arrow-down" />
      </div>
      <!-- 列表 -->
      <div class="menu_list" v-show="isSelect">
        <ul>
          <li
            v-for="item in data"
            :key="item.id"
            @click="selectItem($event, item)"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.select_temp {
  width: auto;
  .select_border {
    display: flex;
    align-items: center;
    border: 1px solid #0086c5;
    position: relative;
    .left_text {
      padding: 0 0.25em;
      color: #82b0ec;
      span {
        font-size: 0.75em;
      }
    }
    .right_icon {
      padding: 0 0.25em;
      border-left: 1px solid #0086c5;
      color: #0086c5;
      cursor: pointer;
    }
    .menu_list {
      position: absolute;
      top: calc(100% + 1px);
      left: -1px;
      box-sizing: content-box;
      width: 100%;
      height: auto;
      z-index: 888;
      background-color: #000a2e;
      border-left: 1px solid #0086c5;
      border-right: 1px solid #0086c5;
      ul {
        li {
          border-bottom: 1px solid #0086c5;
          cursor: pointer;
          span {
            font-size: 0.75em;
            color: #82b0ec;
          }
        }
        li:hover {
          background: #0e7383;
        }
      }
    }
  }
}
</style>

<script>
export default {
  props: ["data","placeholder"],
  data() {
    return {
      isSelect: false,
      selectName: "请选择",
    };
  },
  created() {
    this.selectName = this.placeholder;
  },
  mounted() {
    window.addEventListener("click", () => {
      this.isSelect = false;
    });
  },

  methods: {
    toSelect(e) {
      e.stopPropagation();
      this.isSelect = !this.isSelect;
    },
    // 选择menu
    selectItem(e, data) {
      e.stopPropagation();
      this.isSelect = false;
      this.selectName = data.name;
      this.$emit("change", data.value);
    },
  },
};
</script>